import React, { useState } from 'react';

const AddContributionModal = ({ onClose, onAdd }) => {
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      onAdd({ text: text.trim() });
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4">
        <div className="flex justify-between items-center border-b border-[#E6E6E6] pb-6 mb-6">
          <h2 className="text-[16px] font-bold text-[#3C3C3C]">ADD NOTABLE CONTRIBUTIONS</h2>
          <div className="flex gap-2">
            <button onClick={onClose} className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg">Cancel</button>
            <button onClick={handleSubmit} className="px-4 py-2 bg-[#2283FF] text-white rounded-lg">Save</button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-[#3C3C3C] mb-2">ADD TEXT</label>
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="ex: Developed Player X to National Team"
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-[#1A212FB2] text-[14px] placeholder:text-[#1A212F66] resize-none"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddContributionModal; 